export const TOYOTA_ACADEMY_ADMINISTRATOR = 'lhramirez';

export const institutionMapper = {
  'TOYOTA DEL ECUADOR S.A.': {
    'institution': 'Toyota del Ecuador',
    'ogridnumber': 'TDE',
  },
  'CASABACA S. A.': {
    'institution': 'Casabaca',
    'ogridnumber': 'CASABACA',
  },
  'TOYOCOSTA S. A.': {
    'institution': 'Toyocosta',
    'ogridnumber': 'TOYOCOSTA',
  },
  'IMPORTADORA TOMEBAMBA S.A.': {
    'institution': 'Importadora Tomebamba',
    'ogridnumber': 'EC_ITSA',
  },
};

export const departments = {
  'Comercial': 'Comercial',
  'Ventas': 'Ventas',
  'Marketing': 'Marketing',
  'Administrativo': 'Administrativo',
  'Asistente de agencia': 'Asistente de agencia',
  'Asesor de entrega': 'Asesor de entrega',
  'Ventas Virtual': 'Ventas Virtual',
  'Auxiliar de Ventas': 'Auxiliar de Ventas',
  'Ventas F&I': 'Ventas F&I',
  'Ventas CDN': 'Ventas CDN',
  'Servicio CUE': 'Servicio CUE',
};

export const workPositions = {
  'PVADMINVTA': 'Pto. Venta - Administrativo Ventas',
  'PVREPYACC': 'Pto. Venta - Repuestos y Accesorios',
  'PVASESOR': 'Pto. Venta - Asesor Comercial',
  'PVANFIT': 'Pto. Venta - Anfitriona',
  'PVSERV': 'Pto. Venta - Servicio',
  'PVADMIN': 'Pto. Venta - Administrativo',
  'PVGTEVTA': 'Pto. Venta - Gerente de Ventas',
  'PVGM': 'Pto. Venta - Gerente General',
  'PVINST': 'Pto. Venta - Instructor',
  'DISTDIRCOM': 'Distribuidor - Director Comercial',
  'DISTGTECOM': 'Distribuidor - Gerente Comercial',
  'DISTINST': 'Distribuidor - Instructor',
  'DISTADMINVTA': 'Distribuidor - Administrativo Ventas',
  'DISTGTEMKT': 'Distribuidor - Gerente de Marketing',
  'DISTGM': 'Distribuidor - Gerente General',
  'DISTADMIN': 'Distribuidor - Administrativo',
  'DISTREPYACC': 'Distribuidor - Repuestos y Accesorios',
  'DISTSERV': 'Distribuidor - Servicio',
  'ADMONOT': 'Otros - Administrativo',
  'REPACCES': 'Otros - Repuestos y Accesorios',
  'SVCOOT': 'Otros Servicios',
};

export const csvColumns = [
  'timemodified',
  'deleted',
  'idnumber',
  'username',
  'firstname',
  'lastname',
  'email',
  'country',
  'city',
  'lang',
  'manageridnumber',
  'orgidnumber',
  'posidnumber',
  'postitle',
  'institution',
  'department',
  'phone1',
];
